import DOMPurify, { type Config } from 'dompurify';

const INLINE_CONFIG: Config = {
    ALLOWED_TAGS: ['b', 'br', 'em', 'i', 'p', 'span', 'strong'],
    ALLOWED_ATTR: [],
};

const RICH_TEXT_CONFIG: Config = {
    ALLOWED_TAGS: [...(INLINE_CONFIG.ALLOWED_TAGS as string[]), 'a', 'li', 'ol', 'ul'],
    ALLOWED_ATTR: ['href', 'rel', 'target'],
};

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

export function sanitizeInline(html: string | undefined | null): string {
    return DOMPurify.sanitize(html ?? '', INLINE_CONFIG);
}

export function sanitizeRichText(html: string | undefined | null): string {
    return DOMPurify.sanitize(html ?? '', RICH_TEXT_CONFIG);
}
